import React       from 'react';
import packageJson from '../../package.json';
import preval      from 'preval.macro';

class ReleaseInfoComponent extends React.Component {

  render () {
    return (
      <div>
        {packageJson.name} - web portal {packageJson.version}
        <br/>
        Release Date: {preval`module.exports = new Date().toLocaleString();`}
      </div>
    );
  }
}

ReleaseInfoComponent.propTypes = {};

ReleaseInfoComponent.defaultProps = {};

export default ReleaseInfoComponent;
